import { render, staticRenderFns } from "./course_internet.vue?vue&type=template&id=478f761e&scoped=true"
import script from "./course_internet.vue?vue&type=script&lang=js"
export * from "./course_internet.vue?vue&type=script&lang=js"
import style0 from "./course_internet.vue?vue&type=style&index=0&id=478f761e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478f761e",
  null
  
)

export default component.exports